/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseListLong
 */
export interface ResponseListLong {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListLong
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListLong
     */
    message?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ResponseListLong
     */
    data?: Array<number>;
}

/**
 * Check if a given object implements the ResponseListLong interface.
 */
export function instanceOfResponseListLong(value: object): value is ResponseListLong {
    return true;
}

export function ResponseListLongFromJSON(json: any): ResponseListLong {
    return ResponseListLongFromJSONTyped(json, false);
}

export function ResponseListLongFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListLong {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ResponseListLongToJSON(json: any): ResponseListLong {
    return ResponseListLongToJSONTyped(json, false);
}

export function ResponseListLongToJSONTyped(value?: ResponseListLong | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'],
    };
}

